import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {ScrollingModule} from "@angular/cdk/scrolling";

import {CommonsModule} from "../../commons/angular/commons.module";
import {TranslateModule} from "@ngx-translate/core";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {NgxPermissionsModule} from "ngx-permissions";
import {FormsModule} from "@angular/forms";
import {NgSelectModule} from "@ng-select/ng-select";
import {
  SubTaskTemplateMultiSelectComponent
} from "./components/sub-task-template-multi-select/sub-task-template-multi-select.component";
import {
  SubTaskTemplateMultiSelectListComponent
} from "./components/sub-task-template-multi-select-list/sub-task-template-multi-select-list.component";

@NgModule({
  declarations: [
    SubTaskTemplateMultiSelectComponent,
    SubTaskTemplateMultiSelectListComponent
  ],
  imports: [
    BrowserModule,
    ScrollingModule,
    CommonsModule,
    NgbModule,
    TranslateModule.forChild(),
    NgxPermissionsModule.forChild(),
    FormsModule,
    NgSelectModule
  ],
  providers: [],
  exports: [
    SubTaskTemplateMultiSelectComponent
  ]
})

export class SubTasksModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapSubTasksModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(SubTasksModule);
};

export const downgradedSubTasksModule = downgradeModule(bootstrapSubTasksModule);
